import { memo, useEffect, useState } from "react";

import { useTheme } from "../../theme/ThemeContext";
import MarketDataService from "../../services/market/MarketDataService";


const PriceChange = memo(({ symbol, digits = 2, style }) => {
    const theme = useTheme();

    const [change, setChange] = useState(() =>
        MarketDataService.getPriceChange(symbol)
    );

    useEffect(() => {
        if (!symbol) return;

        const handlePriceUpdate = () => {
            const newChange = MarketDataService.getPriceChange(symbol);
            setChange(newChange);
        };

        const unsubscribe = MarketDataService.subscribe(symbol, handlePriceUpdate);

        return unsubscribe;
    }, [symbol]);

    const formatPercentage = (value) => {
        if (typeof value !== "number" || isNaN(value)) return "0.00%";
        return `${value.toFixed(2)}%`;
    };

    const color = change?.isPositive ? theme.pos : theme.neg;

    return (
        <span
            style={{
                fontSize: 14,
                fontWeight: 600,
                color: color,
                fontFamily: theme.sans,
                ...style,
            }}
        >
            {formatPercentage(change?.percentage)}
        </span>
    );
});

PriceChange.displayName = "PriceChange";

export default PriceChange;